import { Card } from "@/components/ui/card";
export default function HowItWorks() {
  const steps = [{
    number: "1",
    label: "FRICTIONLESS SOFT SCAN",
    heading: "Client Scans QR",
    body: "At the end of their session, the client scans the gold-rimmed QR card printed elegantly on your table. No app download, no login required."
  }, {
    number: "2",
    label: "3-SEC CHECKOUT",
    heading: "Selects & Pays Instantly",
    body: "Client chooses a 3-pack or 5-pack package. Checkout takes 3 seconds with Apple Pay, Google Pay, or Credit Card. Spa receives upfront cash immediately."
  }, {
    number: "3",
    label: "ZERO MANUAL TRACKING",
    heading: "Sessions Auto-Tracked",
    body: "PrepayQR handles the tracking. Unused sessions are auto-deducted when they book next. Your therapists do zero manual bookkeeping."
  }, {
    number: "4",
    label: "87% NO-SHOW DROP",
    heading: "Clients Rebook & Show Up",
    body: 'Client receives an automated text: "2 sessions left. Rebook?" Prepaid clients show up. No-shows drop by 87% because sessions are already paid for.'
  }];
  return <section id="how-it-works" style={{
    backgroundColor: "rgb(255, 255, 255)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(42, 45, 43)",
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    paddingTop: "96px",
    paddingBottom: "96px",
    animation: "none 0s ease 0s 1 normal none running"
  }}>
      <div className="page-container">
        <div className="flex flex-col items-center text-center mb-12">
          <p style={{
          color: "#C8985C",
          fontSize: "11px",
          fontWeight: 500,
          letterSpacing: "0.12em",
          textTransform: "uppercase",
          marginBottom: "12px",
          fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
        }}>
            THE OPERATIONAL LOOP
          </p>

          <h2 style={{
          color: "rgb(31, 58, 46)",
          fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          fontSize: "36px",
          fontWeight: "400",
          lineHeight: "40px",
          border: "0px solid oklch(0.69 0.04 165 / 0.25)",
          textAlign: "center",
          animation: "none 0s ease 0s 1 normal none running",
          marginBottom: "12px"
        }}>
            Turn every massage table into a{" "}
            <em style={{
            color: "#C8985C",
            fontStyle: "italic"
          }}>silent closer</em>
            <span style={{
            color: "rgb(31, 58, 46)"
          }}>.</span>
          </h2>

          <p style={{
          color: "rgba(42, 45, 43, 0.7)",
          fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
          fontSize: "16px",
          fontWeight: "400",
          lineHeight: "24px",
          border: "0px solid oklch(0.69 0.04 165 / 0.25)",
          textAlign: "center",
          animation: "none 0s ease 0s 1 normal none running",
          maxWidth: "600px"
        }}>
            Clients scan, pay, and rebook themselves—while you and your therapists keep working.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map(step => <div key={step.number} className="flex flex-col">
              <div className="flex flex-row items-center gap-3 mb-3">
                <div style={{
              backgroundColor: "#C8985C",
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0
            }}>
                  <span style={{
                color: "#FFFFFF",
                fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
                fontSize: "16px",
                fontWeight: "700",
                lineHeight: 1
              }}>
                    {step.number}
                  </span>
                </div>

                <span style={{
              color: "#C8985C",
              fontSize: "10px",
              fontWeight: 500,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
            }}>
                  {step.label}
                </span>
              </div>

              <div className="flex-1" style={{
            backgroundColor: "oklch(96% .01 80)",
            borderRadius: "10px",
            border: "1px solid oklch(69% .04 165 / 0.25)",
            padding: "24px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)"
          }}>
                <h4 style={{
              color: "rgb(31, 58, 46)",
              fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
              fontSize: "18px",
              fontWeight: "600",
              lineHeight: "1.4",
              marginBottom: "8px"
            }}>
                  {step.heading}
                </h4>

                <p style={{
              color: "rgba(42, 45, 43, 0.7)",
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "22.75px",
              border: "0px solid oklch(0.69 0.04 165 / 0.25)",
              animation: "none 0s ease 0s 1 normal none running",
              margin: 0
            }}>
                  {step.body}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}